module.exports = __webpack_public_path__ + "static/media/002 I GUERRA M_Piazza della Vittoria.c925370d.svg";